// Packages:
import styled from 'styled-components'


// Exports:
export const Container = styled.div`
  height: 99%;
  width: 99%;
  margin-top: 7rem;
`

export const Wrapper = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;
  gap: 0.75rem;
  height: 100%;
  width: 100%;
`

export const Options = styled.div`
  display: flex;
  font-size: 14px;
  flex-direction: row;
  align-items: center;
  margin-bottom: 1rem;
  justify-content: center;
`

